import { render, staticRenderFns } from "./rich_text.vue?vue&type=template&id=2a7746be&"
import script from "./rich_text.vue?vue&type=script&lang=js&"
export * from "./rich_text.vue?vue&type=script&lang=js&"
import style0 from "./rich_text.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports